import { useEffect, useState } from "react";

/**
 * Returns true when the current viewport is < 768px (matches Tailwind `md`).
 * SSR-safe. Updates on resize.
 */
export function useIsMobile(breakpoint = 768) {
  const get = () =>
    typeof window !== "undefined" && window.innerWidth < breakpoint;
  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const on = () => setIsMobile(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [breakpoint]);

  return isMobile;
}
